/** Routes that should show the truck loader during client-side navigation. */
export const ROUTE_LOADER = {
    localePrefixPattern: /^\/(en|te|hi|gu|kn|mr|ta|bn)(?=\/|$)/,
    serverRenderedPaths: {
        nextjs: [
            /^\/login$/,
            /^\/help(\/.*)?$/,
            /^\/forum(\/.*)?$/,
            /^\/marketplace(\/.*)?$/,
            /^\/transporters(\/.*)?$/,
            /^\/membership\/upgrade$/,
            /^\/ac\/my-loads(\/.*)?$/,
            /^\/ac\/my-lorries(\/.*)?$/,
            /^\/dashboard(\/.*)?$/,
            /^\/my-profile(\/.*)?$/
        ],
        admin: [
            /^\/mw\/tso\/market(\/.*)?$/,
            /^\/customer-marketplace(\/.*)?$/,
            /^\/customer-loads(\/.*)?$/,
            // load detail pages use getStaticProps + fallback:blocking — wait shows no UI without this
            /^\/ticket-system\/loads\/[^/]+\/[^/]+/
        ]
    }
} as const;

export type RouteLoaderApp = keyof typeof ROUTE_LOADER.serverRenderedPaths;
